import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchAdmins = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/admins/`);
    if (!response.ok) throw new Error("Не вдалося завантажити адміністраторів");
    return response.json();
};

export const updateAdmin = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/admins/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити адміністратора");
    }
    return response.json();
};

export const addAdmin = async (data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/admins/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати адміністратора");
    }
    return response.json();
};